import {
  PersonUsesBookChildDto,
  PersonUsesBookDto,
} from './person-uses-book.model';
import { PersonUsesBook } from '@lyceo/lyceo-pupil-app/practise/util-models';
import { ScopeDto } from '../scope/scope.model';

export function mapPersonUsesBook(
  personUsesBookDto: PersonUsesBookDto | PersonUsesBookChildDto,
  scopeId: string,
): PersonUsesBook {
  return {
    id: personUsesBookDto.id,
    bookId: personUsesBookDto.bookId,
    personId: personUsesBookDto.personId,
    isActive: personUsesBookDto.isActive,
    lastUsedParagraphId: personUsesBookDto.lastUsedParagraphId,
    lastUsedAt: personUsesBookDto.lastUsedAt,
    scopeId,
  };
}

export function mapScopesToPersonUsesBooks(
  scopes: ScopeDto[],
): PersonUsesBook[] {
  return scopes.reduce((total: PersonUsesBook[], scopeDto) => {
    if (scopeDto.personUsesBook) {
      total.push(mapPersonUsesBook(scopeDto.personUsesBook, scopeDto.id));
    }
    return total;
  }, []);
}
